import type { PickerEntry } from "../types";

export const MINIMUM_VISUAL_NAMES = 100;

export interface VisualEntry {
  id: string;
  name: string;
  category: string | null;
  isDummy: boolean;
}

const NON_LATIN_DUMMY_NAMES = [
  "あかり",
  "さくら",
  "ひかり",
  "はると",
  "ゆい",
  "れん",
  "かおり",
  "けんた",
  "みさき",
  "そうた",
  "子轩",
  "美玲",
  "浩然",
  "雨桐",
  "明哲",
  "静怡",
  "俊杰",
  "芳华",
  "若曦",
  "宇航",
  "민준",
  "서연",
  "지우",
  "하준",
  "수빈",
  "예준",
  "도윤",
  "지민",
  "현우",
  "유진",
  "ليلى",
  "عمر",
  "نور",
  "يوسف",
  "مريم",
  "أحمد",
  "سلمى",
  "خالد",
  "ياسمين",
  "كريم",
  "आरव",
  "अनन्या",
  "ईशान",
  "काव्या",
  "मीरा",
  "विवान",
  "सान्वी",
  "अद्वैत",
  "रिया",
  "कबीर",
  "Алексей",
  "Алина",
  "Дмитрий",
  "Елена",
  "Ирина",
  "Николай",
  "София",
  "Михаил",
  "Татьяна",
  "Сергей",
  "Αλέξανδρος",
  "Ελένη",
  "Νίκος",
  "Σοφία",
  "Γιάννης",
  "Μαρία",
  "Δημήτρης",
  "Κατερίνα",
  "Ανδρέας",
  "Ιωάννα",
  "อาทิตย์",
  "กัญญา",
  "นิรันดร์",
  "พิม",
  "ศิริพร",
  "สมชาย",
  "อนันต์",
  "มาลี",
  "ธนา",
  "สุภา",
  "נועה",
  "איתן",
  "יעל",
  "דוד",
  "מרים",
  "יוסף",
  "תמר",
  "רון",
  "אביגיל",
  "אריאל",
  "ნინო",
  "გიორგი",
  "თამარ",
  "ლუკა",
  "ანა",
  "დავით",
  "მარიამ",
  "ირაკლი",
  "სალომე",
  "ლევანი",
  "Անի",
  "Դավիթ",
  "Մարիամ",
  "Նարեկ",
  "Լիլիթ",
  "Արման",
  "Սոնա",
  "Հայկ",
  "Գայանե",
  "Տիգրան",
  "আরিফ",
  "মেহজাবিন",
  "রাহুল",
  "সুমাইয়া",
  "তানভীর",
  "নুসরাত",
  "ইমরান",
  "প্রিয়া",
  "সায়ন",
  "অনন্যা",
  "அருண்",
  "காவ்யா",
  "கார்த்திக்",
  "மீனா",
  "சூர்யா",
  "நித்யா",
  "விஜய்",
  "அனிதா",
  "பிரவீன்",
  "லக்ஷ்மி",
] as const;

function normalizedName(name: string): string {
  return name.trim().toLocaleLowerCase();
}

export function buildVisualPool(
  entries: PickerEntry[],
  minimum = MINIMUM_VISUAL_NAMES,
): VisualEntry[] {
  const visualEntries: VisualEntry[] = entries.map((entry) => ({
    id: entry.id,
    name: entry.name,
    category: entry.category,
    isDummy: false,
  }));
  const usedNames = new Set(visualEntries.map((entry) => normalizedName(entry.name)));

  for (const [index, name] of NON_LATIN_DUMMY_NAMES.entries()) {
    if (visualEntries.length >= minimum) break;
    if (usedNames.has(normalizedName(name))) continue;
    usedNames.add(normalizedName(name));
    visualEntries.push({
      id: `visual-dummy-${index}`,
      name,
      category: "Display only",
      isDummy: true,
    });
  }

  return visualEntries;
}
